import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { RoutingService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Subscription } from "rxjs";
import { CreateNewTicketComponent } from "../create-new-ticket/create-new-ticket.component";
import { CustomCustomerServiceBrService } from "../custom-customer-service-br.service";
import { TicketDetailsComponent } from "../ticket-details/ticket-details.component";


@Component({
    selector: 'app-customer-service-page',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './customer-service-page.component.html',
    styleUrls: ['./customer-service-page.component.scss'],
    standalone: false
})
export class CustomerServicePageComponent implements OnInit, OnDestroy {
  public recentTickets = [];
  userId: any;
  ticketdetails: any;
  ticketToDisplay: any;
  ticketsToBeDisplayed = [];
  ticketToDisplaySubscriber: Subscription;
  constructor(
    private readonly user: UserAccountFacade,
    private readonly modalService: NgbModal,
    private readonly customerService: CustomCustomerServiceBrService,
    private readonly cdr: ChangeDetectorRef,
    private readonly route: RoutingService
  ) {}

  ngOnInit() {
    this.user.get().subscribe((res: any) => {
      if (res) {
        this.userId = res?.userName;
      }
      if (this.userId) {
        const params='currentPage=0&pageSize=10&sort=byDate&status=Open';
        this.customerService.getTicketsToDisplay(this.userId,params);
        this.ticketToDisplaySubscriber =
          this.customerService.ticketsToDisplay.subscribe((res: any) => {
            if (res) {
              this.recentTickets = res?.tickets;
              this.cdr.detectChanges();
            }
          });
      }
    });
  }

  openCreateTicketModal(): void {
    this.customerService.getTicketCategories();
    this.modalService.open(CreateNewTicketComponent, {
      windowClass: 'product-details-modal create-new-ticket',
    });
  }
  openAllTickets() {
    const params = 'currentPage=0&pageSize=18&sort=byTicketId';
    this.customerService.getTicketsToDisplay(this.userId, params);
    this.route.goByUrl('/tickets');
  }
  viewTicket(ticketId): void {
    this.customerService.getTicketDetails(ticketId, this.userId);
    this.modalService.open(TicketDetailsComponent, {
      windowClass: 'ticketdetails-viewmodal',
    });
  }
  closeAlert() {}

  ngOnDestroy() {}
}
